'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MERCHANT = exports.MERCHANT = 'merchant';
var FULFILLER = exports.FULFILLER = 'fulfiller';